const tblSingle = {
  55: [8, 14, 21, 24.3],
  56: [9, 15, 22, 25.3],
  57: [10, 16.5, 23, 26.2],
  58: [11.5, 17.5, 24, 28.3],
  59: [12.5, 18.5, 25, 29.3],
  60: [14, 19.5, 26, 31],
  61: [15, 20.5, 27, 32],
  62: [16, 21.5, 28, 33],
  63: [17, 23, 29, 34],
  64: [18, 24, 30, 35],
  65: [19.5, 25.5, 31, 36],
  66: [21, 27, 32, 37],
  67: [22, 28, 33, 38],
  68: [23, 29, 34, 39],
  69: [24.5, 30.5, 35, 40],
  70: [26, 32, 36, 41.3],
  71: [27, 33, 37, 42.5],
  72: [28, 34, 38, 43.7],
  73: [28.5, 34.5, 39, 44.9],
  74: [29, 35, 40, 46],
  75: [30, 36, 41, 47.3],
  76: [30.5, 36.5, 42, 48.3],
  77: [31, 37, 43, 49.3],
  78: [32, 38, 44, 50.3],
  79: [33, 39, 45, 50.9],
  80: [34, 40, 46, 51.8],
  81: [35, 41, 47, 53],
  82: [36, 42, 48, 53.6],
  83: [37, 43, 49, 53.8],
  84: [38, 44, 50, 54],
  85: [38, 44, 50, 54],
  86: [38, 44, 50, 54],
  87: [38, 44, 50, 54],
  88: [38, 44, 50, 54],
  89: [38, 44, 50, 54],
  90: [38, 44, 50, 54],
};

const tblJoint = {
  55: [8, 14, 21, 24.3],
  56: [9, 15, 22, 25.3],
  57: [10, 16.5, 23, 26.2],
  58: [11.5, 17.5, 24, 28.3],
  59: [12.5, 18.5, 25, 29.3],
  60: [14, 19.5, 26, 31],
  61: [15, 20.5, 27, 32],
  62: [16, 21.5, 28, 33],
  63: [17, 23, 29, 34],
  64: [18, 24, 30, 35],
  65: [19.5, 25.5, 31, 36],
  66: [21, 27, 32, 37],
  67: [22, 28, 33, 38],
  68: [23, 29, 34, 39],
  69: [24.5, 30.5, 35, 40],
  70: [26, 32, 36, 41.3],
  71: [27, 33, 37, 42.5],
  72: [28, 34, 38, 43.7],
  73: [28.5, 34.5, 39, 44.9],
  74: [29, 35, 40, 46],
  75: [30, 36, 41, 47.3],
  76: [30.5, 36.5, 42, 48.3],
  77: [31, 37, 43, 49.3],
  78: [32, 38, 44, 50.3],
  79: [33, 39, 45, 50.9],
  80: [34, 40, 46, 51.8],
  81: [35, 41, 47, 53],
  82: [36, 42, 48, 53.6],
  83: [37, 43, 49, 53.8],
  84: [38, 44, 50, 54],
  85: [38, 44, 50, 54],
  86: [38, 44, 50, 54],
  87: [38, 44, 50, 54],
  88: [38, 44, 50, 54],
  89: [38, 44, 50, 54],
  90: [38, 44, 50, 54],
};

// const isValid = x => (typeof x !== 'undefined' && x !== null && !isNaN(x));

export const getLtvValue = ({ clientAge, isJoint, housePrice, ltvPlan }) => {
  const age = clientAge > 90 ? 90 : clientAge;
  const tbl = isJoint ? tblJoint[age] : tblSingle[age];
  const Healthy = parseInt(housePrice * 0.01 * tbl[0], 10);
  const Mild = parseInt(housePrice * 0.01 * tbl[1], 10);
  const Moderate = parseInt(housePrice * 0.01 * tbl[2], 10);
  const Severe = parseInt(housePrice * 0.01 * tbl[3], 10);

  const result = { Healthy, Mild, Moderate, Severe };
  result.max = result[ltvPlan || "Severe"];
  result.diff = result.Severe - result.Healthy;
  result.pct = {
    Healthy: tbl[0],
    Mild: tbl[1],
    Moderate: tbl[2],
    Severe: tbl[3],
  };
  return result;
};



// WEBPACK FOOTER //
// ./src/services/LtvCalc.js